import { render } from "./search-supplier-boxes.vue?vue&type=template&id=39831c28"
import script from "./search-supplier-boxes.vue?vue&type=script&lang=js"
export * from "./search-supplier-boxes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__